<template>
  <base-layout :loading="loading">
    <v-row v-if="ready">
      <v-col cols="12">
        <v-row>
          <v-col cols="4">
            <p><span class="font-weight-bold">Order ID</span> : {{ billDetail.id }}</p>
          </v-col>
          <v-col cols="4">
            <p><span class="font-weight-bold">Status</span> : {{ statusTranslated.text }}</p>
          </v-col>
          <v-col
            v-if="statusTranslated.text === 'จัดส่งแล้ว'"
            cols="4">
            <p><span class="font-weight-bold">เลข Tracking</span> : {{ billDetail.tacking }}</p>
          </v-col>
          <v-col cols="12">
            <p class="font-weight-bold">
              แบรนด์ : {{ brand.name }}
            </p>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12">
        <order
          :items="items"
          :bill="billDetail"
          :customer="customer"
          :brand="brand"
          @editNote="editNote($event)"
          @trackingNumber="completeOrder($event)" />
      </v-col>
      <v-col cols="12">
        <v-btn
          icon
          @click="$router.go(-1)">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </base-layout>
</template>

<script>
import { mapActions } from 'vuex'
import OrderProvider from '@/resources/OrderProvider'
import SmsProvider from '@/resources/SmsProvider'
import order from '../components/order.vue'

const orderService = new OrderProvider()
const smsService = new SmsProvider()

export default {
  components: {
    order
  },
  data () {
    return {
      paramID: this.$route.params.id,
      loading: false,
      ready: false,
      items: [],
      brand: {},
      statusTranslated: '',
      billDetail: {
        id: '',
        status: '',
        expire: '',
        link: '',
        shippingPrice: '',
        discount: '',
        net: '',
        tacking: '',
        brand: '',
        note: ''
      },
      customer: {
        name: '',
        tel: '',
        address: '',
        subDistrict: '',
        district: '',
        province: '',
        postcode: '',
        country: ''
      },
      bill: undefined,
      tel: ''
    }
  },
  async created () {
    await this.getOrderDetail()
    this.statusTranslated = this.displayOrderStatus({
      currentState: this.billDetail.status,
      expire: this.billDetail.expire,
      note: this.billDetail.note
    })
    this.ready = true
  },
  methods: {
    ...mapActions({
      setSnackbar: 'Style/setSnackbar',
      setModal: 'Style/setModal'
    }),
    async editNote (message) {
      const updateNote = await this.updateNote(message)
      if (updateNote) {
        await Promise.all([this.sendSms(message), this.getOrderDetail()])
        this.setModal({
          value: true,
          title: 'สำเร็จ',
          message: 'แก้ไขรายการสำเร็จแล้ว',
          confirmOnly: true,
          onConfirm: () => this.$router.push({ name: 'Fulfillment' })
        })
      }
    },
    async completeOrder (trackingNo) {
      const isDeduct = await this.deductStock()
      if (isDeduct) {
        const tracked = await this.initTrack(trackingNo)
        const msg = `ออเดอร์ ${this.billDetail.id} จากแบรนด์ ${this.brand.name} ถูกจัดส่งแล้ว สามารถตรวจสอบสถานะได้จาก Tracking No. ${trackingNo}`
        let customerTel = this.customer.tel
        if (customerTel.length === 10 && customerTel[0] === '0') {
          customerTel = customerTel.substr(1)
          customerTel = `+66${customerTel}`
        }
        if (tracked) {
          await Promise.all([
            this.sendSms(msg, customerTel),
            this.sendSms(msg)
          ])
          this.setModal({
            value: true,
            title: 'สำเร็จ',
            message: 'เปลี่ยนสถานะบิลแล้ว',
            confirmOnly: true,
            onConfirm: () => this.$router.push({ name: 'Fulfillment' })
          })
        }
      }
    },
    async sendSms (message, reciever) {
      let sms
      const tel = reciever || this.brand.phone1

      try {
        sms = await smsService.sendSingle({
          tel,
          text: message
        })
      } catch (error) {
        console.error(error)
      }
      return sms
    },
    async getOrderDetail () {
      this.loading = true
      try {
        const { data } = await orderService.getBillById(this.paramID)
        this.bill = data.bill
        const { bill, brand } = data
        this.items = bill.items
        this.billDetail = {
          id: bill.id,
          expire: bill.expire,
          status: bill.currentState,
          link: `https://bill.akitahub.com/th/b/${bill.url}`,
          shippingPrice: parseFloat(bill.shipCost),
          discount: parseFloat(bill.discount),
          net: parseFloat(bill.net),
          tacking: bill.shippingRefCode,
          note: bill.note
        }
        this.customer = {
          name: bill.customerName,
          tel: bill.customerTel,
          address: bill.customerAddress,
          subDistrict: bill.customerSubDistrict,
          district: bill.customerDistrictCity,
          province: bill.customerStateProvince,
          postcode: bill.customerPostcode,
          country: bill.customerCountry
        }
        this.brand = brand
        if (this.brand.phone1[0] === '0') {
          this.brand.phone1 = this.brand.phone1.substr(1)
          this.brand.phone1 = `+66${this.brand.phone1}`
        }
      } catch (error) {
        console.error(error)
      }
      this.loading = false
    },
    async updateNote (note) {
      this.loading = true
      let returnMessage
      try {
        const { message } = await orderService.updateNote(this.bill.id, { note })
        returnMessage = message === 'done'
      } catch (error) {
        console.error(error)
        returnMessage = false
      }
      this.loading = false
      return returnMessage
    },
    async deductStock () {
      this.loading = true
      let returnMessage
      try {
        const { data } = await orderService.deductStock(this.bill.id)
        returnMessage = data.success === 1
      } catch (error) {
        console.error(error)
        if (error.code === 400 && error.message.includes('Not enough stock')) {
          this.setModal({
            value: true,
            title: 'สินค้าไม่เพียงพอ',
            message: error.message,
            confirmOnly: true
          })
        } else {
          this.setModal({
            value: true,
            title: 'เกิดข้อผิดพลาด',
            message: `code : ${error.code}\nกรุณาลองใหม่อีกครั้ง หรือติดต่อเจ้าหน้าที่`,
            confirmOnly: true
          })
        }
        returnMessage = false
      }
      this.loading = false
      return !!returnMessage
    },
    async initTrack (trackingNo) {
      this.loading = true
      let result = false
      try {
        const { data } = await orderService.billTracking(this.bill.id, { shippingNumber: trackingNo })
        result = data.success === 1
      } catch (e) {
        console.error(e)
        this.setModal({
          value: true,
          title: 'เกิดข้อผิดพลาด',
          message: `code : ${e.code}\nกรุณาลองใหม่อีกครั้ง หรือติดต่อเจ้าหน้าที่`,
          confirmOnly: true
        })
      }
      this.loading = false
      return !!result
    },
    displayOrderStatus (bill) {
      const now = this.$dayjs()
      const billExpire = this.$dayjs(bill.expire)
      if (bill.currentState) {
        switch (bill.currentState) {
          case 'paid':
            return { text: 'จัดส่งแล้ว', color: 'purple' }
          case 'confirmed': {
            if (now - billExpire > 0) {
              return { text: 'หมดอายุ', color: 'grey darken-1' }
            }
            if (bill.note && bill.note !== '') {
              return { text: 'รอแก้ไข', color: 'warning' }
            }
            return { text: 'รอจัดส่ง', color: 'success' }
          }
          default: return { text: 'Unknow', color: 'grey darken-4' }
        }
      } else {
        return { text: 'Unknow', color: 'grey darken-4' }
      }
    }
  }
}
</script>

<style scoped>
.back-btn {
  position: absolute;
  bottom: 5px;
}
</style>
